import { render, staticRenderFns } from "./QuizletWidget.vue?vue&type=template&id=351bfcaa"
import script from "./QuizletWidget.vue?vue&type=script&lang=js"
export * from "./QuizletWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports